import React, { useState, useRef } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useFormikContext } from "formik";
import { PrimaryButton, TextField, Toggle } from '@fluentui/react';
import DropdownTextToggle from './DropdownTextToggle';

const copyObj = {
    dropPlaceholder: 'Choose a journal category or make a new one.',
    addPlaceholder: 'Add a new journal category.',
    btnText: 'Select from existing categories',
    addBtnText: 'Add new category',
    label: 'Journal Category',
    name: 'category'
};

const dropdownTextToggleCss = css`
    .toggle-button { margin-top: 15px; }
`;

const BasicInfoFields = ({ disabled, model, categories, selectedCategory, isNew }) => {
    const { setFieldValue, values } = useFormikContext();
    const [newPrompt, setNewPrompt] = useState(model.prompt);
    const [disableToggle, setDisableToggle] = useState(disabled);
    const initRef = useRef({ ...model });

    return (
        <>
            <DropdownTextToggle
                disabled={disableToggle}
                options={categories}
                selectedCategory={selectedCategory}
                copy={copyObj}
                rootCss={dropdownTextToggleCss}
                isNew={isNew}
                addChange={(e, newValue) => {
                    if (typeof(newValue) === 'string') {
                        setFieldValue("category", newValue);
                        setFieldValue("addCategory", true);
                        setFieldValue("editCategory", false);
                        setFieldValue("switchCategory", false);
                    } else {
                        const change = initRef?.current?.journalCategoryId != newValue.key && initRef?.current?.category != newValue.text;
                        setFieldValue("category", newValue.text);
                        setFieldValue("journalCategoryId", newValue.key);
                        setFieldValue("switchCategory", change);
                        setFieldValue("addCategory", false);
                        setFieldValue("editCategory", false);
                    }
                }}
                editChange={(e, newValue) => {
                    setFieldValue("addCategory", false);
                    setFieldValue("category", newValue);
                    setFieldValue("editCategory", true);
                }}
            />
            <TextField
                disabled={disableToggle}
                label="Journal Prompt"
                name="prompt"
                multiline 
                autoAdjustHeight
                placeholder={model?.prompt}
                value={newPrompt}
                onChange={(e, newValue) => {
                    setFieldValue("prompt", newValue);
                    setNewPrompt(newValue);
                }}
            />
            <Toggle
                disabled={disableToggle}
                label="Checklist only"
                onText="Hidden from journal browsing"
                offText="Browsable in the journal experience"
                checked={!!values.checklistOnly}
                onChange={(e, checked) => setFieldValue("checklistOnly", !!checked)}
            />
            {disableToggle && (
            <div css={css`display: flex; flex-direction: column; align-items: center;`}>
                <p>** Modifying the category or prompt of a journal that already exists will impact all instances of that journal.</p>
                <PrimaryButton 
                    css={css`margin: 15px auto 0px auto;`} 
                    text="Yes I want to edit this journal" 
                    onClick={() => setDisableToggle((prevDisableToggle) => !prevDisableToggle)}
                />
            </div>
            )}
        </>
    );
};

export default BasicInfoFields;
